import styled from 'styled-components';

export const CruiseCardBase = styled.div`
  background-color: ${({ theme }) => theme.palette.background.paper};
  border-radius: ${({ theme }) => theme.shape.borderRadius};
  display: flex;
  font-family: ${({ theme }) => theme.typography.fontFamily};
  flex-direction: row;
  margin-bottom: 30px;
  min-height: 225px;
  overflow: hidden;
  position: relative;
  width: 100%;
`;